import unescapedText from 'I18n/utils/unescapedText';
export const companyNewsActionTextParser = action => {
  return unescapedText('copilotToolkit.streamingMessage.companyNews', {
    domain: action.domain
  });
};